import axios from "axios";
import api from "../../../utils/api";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { RootState } from "../../rootReducer";
import { Document } from "../../../@types/document";
import axiosInstance from "../../../utils/axiosConfig";

export const requestCorrection = createAsyncThunk(
  "documentSignerShow/requestCorrection",
  async (comment: string, { getState, rejectWithValue }) => {
    try {
      const state = getState() as RootState;

      const { data } = await axiosInstance.post(`${api.baseURL}document/request-correction`, {
        comment,
        user: state.userAuthentication.user,
        document: state.documentSignerShow.document,
      });

      return data as Document;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
